// NOTE: REALLY NEED UNIT TESTS FOR THIS FUNCTION
import { USD_UNIT_CONVERSION_FACTOR, ZERO_DECIMAL_CURRENCIES } from 'constants/currency';

/**
 * Converts a formatted price (e.g., $10.99) to a unit amount (e.g., 1099 cents)
 * for use with payment processors like Stripe
 */
export function convertFormattedPriceToUnitAmount(
  formattedAmount: number,
  currency: string,
): number {
  // Normalize currency code
  const currencyCode = currency.toUpperCase();

  // Check if it's a zero-decimal currency
  if (ZERO_DECIMAL_CURRENCIES.includes(currencyCode)) {
    return Math.round(formattedAmount);
  }

  // For currencies with decimals (like USD), multiply by 100
  return Math.round(formattedAmount * USD_UNIT_CONVERSION_FACTOR);
}

/**
 * Converts a unit amount (e.g., 1099 cents) back to a formatted price (e.g., 10.99)
 * for display purposes
 */
export function convertUnitAmountToFormattedPrice(unitAmount: number, currency: string): number {
  // Normalize currency code
  const currencyCode = currency.toUpperCase();

  // Check if it's a zero-decimal currency
  if (ZERO_DECIMAL_CURRENCIES.includes(currencyCode)) {
    return unitAmount;
  }

  // For currencies with decimals (like USD), divide by 100
  return unitAmount / USD_UNIT_CONVERSION_FACTOR;
}
